import { createFileRoute } from "@tanstack/react-router";
import { DashboardShell, PlaceholderCard } from "@/components/DashboardShell";
import { SUPER_ADMIN_NAV } from "@/lib/nav";

export const Route = createFileRoute("/_authenticated/super-admin/admins")({
  head: () => ({
    meta: [
      { title: "Admin management · Landoo Super Admin" },
      { name: "description", content: "Admin management — Landoo super admin console." },
    ],
  }),
  component: () => (
    <DashboardShell title="Admin management" role="Super Admin" items={SUPER_ADMIN_NAV}>
      <PlaceholderCard
        title="Admin management"
        description="Super admin management surface for Admin management."
      />
    </DashboardShell>
  ),
});
